import _mixin from '../_mixin'

export default {
  name: 'SVersionWrap',
  cnName: '固定版本活动-公共部分',
  type: 'activity_version',
  preview: '',
  // 属性相关
  props: {
    coinStr: '',
    coin: '',
    apiList: [
      {
        api: '/v1/uni/official/team-info',
        key: 'homeInfo',
        a_id: 'LG4LKO7NPTR3LPWGGPN4AFCOOY',
        isLogin: '0'
      }
    ],
    btnNoBegin: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/954dab003576d11ce95bf78887dc9a7d.png'
    },
    btnNoFix: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/954dab003576d11ce95bf78887dc9a7d.png'
    },
    btnReceive: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/e96c46b1f23a44568dfabaa3774c3c0c.png'
    },
    btnAlreadyReceive: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/dfdf3ed753d8d09372387335fa5d165d.png'
    },
    btnExpire: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/15121783f60c9f674f6790e300123f99.png'
    },
    modalBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/3e04e8eff75bf37e21385543de3c2124.png',
      style: {
        width: '750px',
        height: '620px'
      }
    },
    modalCloseIcon: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/a9525120a54aa4f2fd502a47c7e629b2.png',
      style: {
        width: '40px',
        height: '40px',
        right: '10px',
        top: '10px'
      }
    },
    modalTitleStyle: '{"padding": "30px 0"}',
    modalTextStyle: '{"color": "#50356D"}',
    modalConfirmBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/01/30/50471ebeffbabb3e7bfb7ba155f933bb.png)","color": "#50356D", "font-weight": "700"}',
    modalCancelBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/01/30/5f5077047474ed8a9fde19936a0dcd21.png)"}'
  },
  propsDesc: [
    {
      target: 'apiList',
      label: '首页接口路由',
      formType: 'list',
      listConfig: [
        {
          title: '接口路由',
          target: 'api'
        },
        {
          title: '接口关键字（涉及到组队相关的，必须得叫homeInfo）',
          target: 'key'
        },
        {
          title: '活动id',
          target: 'a_id'
        },
        {
          title: '是否需要登录',
          target: 'isLogin'
        }
      ]
    },
    {
      target: 'coinStr',
      label: '代币名称'
    },
    {
      target: '公共按钮状态',
      formType: 'divider'
    },
    {
      target: 'btnNoBegin',
      label: '未开始按钮图片',
      formType: 'image'
    },
    {
      target: 'btnNoFix',
      label: '未完成按钮图片',
      formType: 'image'
    },
    {
      target: 'btnReceive',
      label: '已完成按钮图片',
      formType: 'image'
    },
    {
      target: 'btnAlreadyReceive',
      label: '已领取按钮图片',
      formType: 'image'
    },
    {
      target: 'btnExpire',
      label: '已过期按钮图片',
      formType: 'image'
    },
    {
      target: '公共弹窗',
      formType: 'divider'
    },
    {
      target: 'modalBg',
      label: '弹窗背景图',
      formType: 'image'
    },
    {
      target: 'modalCloseIcon',
      label: '关闭按钮',
      formType: 'image'
    },
    {
      target: 'modalTitleStyle',
      label: '标题样式',
      formType: 'textarea'
    },
    {
      target: 'modalTextStyle',
      label: '文本样式',
      formType: 'textarea'
    },
    {
      target: 'modalConfirmBtnStyle',
      label: '确认按钮样式',
      formType: 'textarea'
    },
    {
      target: 'modalCancelBtnStyle',
      label: '取消按钮样式',
      formType: 'textarea'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: []
}
